import Swal from "sweetalert2";

export const confirmAction = (message, onConfirm, confirmText = "Yes", icon) => {
  Swal.fire({
    title: "Confirmation",
    text:
      message != ""
        ? message
        : "Are you sure you want to delete it? This action cannot be restored.",
    icon: icon,
    showCancelButton: true,
    scrollbarPadding: false,
    confirmButtonColor: "#435ebe",
    cancelButtonColor: "#d33",
    confirmButtonText: confirmText
  }).then((result) => {
    if (result.isConfirmed && typeof onConfirm === "function") {
      onConfirm();
    }
  });
};

export const showError = (error, defaultMessage = "Something went wrong!") => {
  let message = defaultMessage;
  if (error?.response?.data?.message) {
    message = error.response.data.message;
  } else if (typeof error === "string") {
    message = error;
  }

  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: message
  });
};

export const showInfoAlert = (message, confirmText = "OK") => {
  Swal.fire({
    icon: "info",
    text: message,
    confirmButtonText: confirmText,
    scrollbarPadding: false,
    confirmButtonColor: "#435ebe"
  });
};
